import { coreTranslations } from 'translations';

const reportingMenuItems = _rootMenu;

function _rootMenu() {
    return {
        i18n: coreTranslations.ng_core_reports,
        linkTitle: 'Reports',
        icon: 'onsolve-reporting-icon',
        routeTo: '/reports',
        isRenderable: true,
        newNav: true,
        accessConfiguration: permissions => permissions.canViewReporting()
    };
}

export default reportingMenuItems;
